const SERVICES_LEAD_MANAGER_KEYS = [
  'service_lead_manager_page',
  'service_lead_manager_wizard',
  'service_lead_manager_create_webhook',
]

/** Lead Manager — getuniq only. */
export const servicesEntries = [
  {
    reducerKey: 'services/list',
    sagaKey: 'servicesListSaga',
    routeKeys: SERVICES_LEAD_MANAGER_KEYS,
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-lead-manager" */ 'modules/Services/NetworksList/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-lead-manager" */ 'modules/Services/NetworksList/store/saga'
      ),
  },
  {
    reducerKey: 'services/lead-manager',
    sagaKey: 'leadManagerSaga',
    routeKeys: SERVICES_LEAD_MANAGER_KEYS,
    importReducer: () =>
      import(
        /* webpackChunkName: "domain-lead-manager" */ 'modules/Services/LeadManager/store/reducer'
      ),
    importSaga: () =>
      import(
        /* webpackChunkName: "domain-lead-manager" */ 'modules/Services/LeadManager/store/saga'
      ),
  },
]
